import React, { useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const SearchableAutoComplete = ({ field, formik }) => {
  const isError = formik.touched[field.name] && Boolean(formik.errors[field.name]);

  // Reset Formik field values when empty
  useEffect(() => {
    if (!formik.values[field.name]) {
      formik.setFieldValue(field.name, ""); // Reset main field
      formik.setFieldValue(field.otherField, ""); // Reset other field if applicable
    }
  }, [formik?.values[field?.name]]);

  return (
    <Autocomplete
      disabled={field?.isDisableField}
      freeSolo
      disableClearable
      options={field.options || []}
      getOptionLabel={(option) => option?.name || ""}
      value={
        !formik.values[field.name]
          ? null // ✅ Ensures the field is empty when Formik value is empty
          : formik.values[field.name] === field.othersValue &&
            formik.values[field.otherField]
          ? { name: formik.values[field.otherField], value: field.othersValue }
          : field.options.find((opt) => opt.value === formik.values[field.name]) || null
      }
      onChange={(event, newValue) => {
        if (!newValue || typeof newValue === "string") {
          formik.setFieldValue(field.name, field.othersValue);
          formik.setFieldValue(field.otherField, newValue || "");
        } else {
          formik.setFieldValue(field.name, newValue.value);
          formik.setFieldValue(field.otherField, "");
        }
      }}
      onInputChange={(event, newInputValue) => {
        if (!newInputValue) {
          formik.setFieldValue(field.name, ""); // ✅ Clears field when input is empty
          formik.setFieldValue(field.otherField, "");
        } else if (event?.type === "change") {
          formik.setFieldValue(field.name, field.othersValue);
          formik.setFieldValue(field.otherField, newInputValue);
        }
        
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            "& .MuiOutlinedInput-root": {
              height: "46px",
              padding: "10px 14px 10px 0px",
              borderRadius: "8px",
              boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
              fontSize: "14px",
              fontWeight: "400",
              backgroundColor: formik.values[field.name] === field.othersValue ? "#f9fafb" : "inherit",
              cursor: field?.isDisableField || field?.readonly ? "not-allowed" : "pointer",
              "&.Mui-disabled": {
                backgroundColor: "#F9FAFB",
                cursor: "not-allowed",
              },
            },
            "& .MuiInputBase-input": {
              height: "100%",
              fontSize: "14px",
              textTransform: "initial",
              marginLeft: "5px",
              cursor: field?.isDisableField || field?.readonly ? "not-allowed" : "text",
            },
            "& .MuiInputBase-input::placeholder": {
              fontSize: "14px",
              color: "#605E71",
              opacity: 1,
            },
          }}
          placeholder={field.placeholder}
          required={false} // ✅ Prevents native tooltip validation
          error={isError} // ✅ Shows error only if touched
          helperText={isError ? formik.errors[field.name] : ""} 
          InputProps={{
            ...params.InputProps,
            type: "search",
            readOnly: field.readonly,
            endAdornment: !params.inputProps.value ?(
              <span
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  display: "flex",
                  alignItems: "center",
                  pointerEvents: "none",
                  cursor: field?.isDisableField || field?.readonly ? "not-allowed" : "pointer",
                }}
              >
                <KeyboardArrowDownIcon style={{ 
                  width: "20px", 
                  height: "20px", 
                  color: field.isDisableField ? "#b1bac9" : isError ? "red" : "#4F5E71" 
                }} />
              </span>
            ) : null,
          }}
        />
      )}
    />
  );
};

export default SearchableAutoComplete;
